export default `
mutation removeLicensePlate($uid: ID!) {
  wmLicensePlateRemove(uid: $uid)
}
`